import { defineStore } from 'pinia'
import { ref } from 'vue'

const DEFAULT_TITLE = 'Unable to Submit'
const DEFAULT_MESSAGE = 'We were unable to process your submission. Please try again.'

export const useSubmissionErrorStore = defineStore('submissionError', () => {
  const visible = ref(false)
  const title = ref(DEFAULT_TITLE)
  const message = ref<string>(DEFAULT_MESSAGE)
  // Per-item reasons listed under the message — a submission can be refused for
  // several things at once (three files, three different problems), and picking
  // one to show would leave the student fixing them one round trip at a time.
  const errors = ref<string[]>([])

  function show(customMessage?: string, customTitle?: string, customErrors?: string[]) {
    const hasCustomMessage = !!customMessage
    message.value = hasCustomMessage ? customMessage! : DEFAULT_MESSAGE
    title.value = customTitle || DEFAULT_TITLE
    errors.value = customErrors ?? []
    visible.value = true
  }

  return { visible, title, message, errors, show }
})
